<template>
  <div class="payee-info">
    <div class="table-container">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="settleAccountsRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :valid-config="{ autoPos: true, message: 'inline' }"
        height="150"
      >
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
        >
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PayeeInfo',
    props: {
      payeeInfoData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableData: this.payeeInfoData,
        tableColumnList: [
          {
            field: 'registerDate',
            title: '收款日期',
          },
          {
            field: 'originReceiveMoneyAmount',
            title: '收款金额',
          },
          {
            field: 'receiveInfoCurrencyName',
            title: '币种',
          },
          {
            field: 'salesOrderNo',
            title: '合同号',
          },
          {
            field: 'customerName',
            title: '客户名称',
          },
          {
            field: 'bankFlowNo',
            title: '收款流水号',
          },
        ],
      };
    },
  };
</script>

<style lang="scss" scoped>
  .payee-info {
    background: #fff;
    .table-container {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
    ::v-deep .vxe-toolbar {
      height: 0 !important;
    }
  }
</style>
